import React, { useRef } from "react";
import { useState } from "react";
import { Editor } from "primereact/editor";
import { sendPostReq, sendPostFileReq } from "../DAL/http";
import { Toast } from 'primereact/toast';



// import 'primereact/resources/themes/saga-blue/theme.css'; // Replace 'saga-blue' with your preferred theme
// import 'primereact/resources/primereact.min.css';
// // import 'primeicons/primeicons.css';
const JobPosts = () => {
  const [file, setFile] = useState();
  const [title, setTitle] = useState("");
  const [desc, setDesc] = useState("");
  const [text, setText] = useState("");
  const toast = useRef(null);


  const showSuccess = (r) => {
    toast.current.show({ severity: 'success', summary: 'Success', detail: r.message, life: 3000 });
  }

  const submitJobPost = async (e) => {
    debugger;
    e.preventDefault();
    let formData = {
      title: title,
      desc: desc,
      editorText: text,
      status: "active",
      createdDate: new Date(),
      modifiedDate: new Date(),
    };
    if (file !== undefined && file.name !== undefined && file.name !== "") {
      debugger;
      const formData1 = new FormData();
      formData1.append("file", file);
      await sendPostFileReq("file-upload/job-post-upload", formData1)
        .then(async (response) => {
          debugger;
          if (response.statusCode === 200) {
            debugger;
            let formData = {
              title: title,
              desc: desc,
              editorText: text,
              image: response.imageUrl,//
              status: "active",
              createdDate: new Date(),
            };
            await sendPostReq("job-openings", formData)
              .then((response1) => {
                debugger;
                showSuccess(response1)
                setTitle("");
                setDesc("");
                setText("");
                // alert(JSON.parse(response1));

                console.log("Saved Successful:", response1);
              })
              .catch((error) => {
                console.error("Error saving user:", error);
              });
          }
        })
        .catch((error) => {
          console.error("Error saving user:", error);
        });
    } else {
      await sendPostReq("job-openings", formData)
        .then((response) => {
          debugger;
          showSuccess(response)
          setTitle("");
          setDesc("");
          setText("");
          setFile("");

          // alert(JSON.parse(response));
          // console.log("Saved Successful:", response);
        })
        .catch((error) => {
          console.error("Error saving user:", error);
        });
    }

    // var formData = new FormData()
    // formData.append('title', title);
    // formData.append('desc', desc);
    // formData.append('editorText', text);
    // console.log(await sendPostReq("/job-openings", formData));
  };

  function handleChange(event) {
    setFile(event.target.files[0]);
  }

  return (
    <>

      <div className="row">

        <div className=" form-container shadow p-3 mb-5 bg-white rounded">
          <Toast ref={toast} style={{ width: "100px" }} position="top-center" />
          <form onSubmit={submitJobPost}>
            <h3 className="mb-3 text-center">Create New Job Post</h3>
            <div className="form-group ">
              <label htmlFor="jobTitle">Job Title:</label>
              <input
                type="text"
                className="form-control"
                id="jobTitle"
                placeholder="Enter job title"
                onChange={(e) => setTitle(e.target.value)}
                value={title}
              />
            </div>
            <div className="form-group ">
              <label htmlFor="jobShortDesc">Job Short Description:</label>
              <textarea
                className="form-control"
                id="jobShortDesc"
                rows={3}
                placeholder="Enter a brief description of the job"
                onChange={(e) => setDesc(e.target.value)}
                value={desc}
              />
            </div>

            <div className="form-group">
              <label htmlFor="imageUpload">Upload Image:</label>
              <input
                type="file"
                className="form-control"
                id="imageUpload"
                accept="image/*"
                onChange={handleChange}
              />
            </div>
            <div>
              <div className="card">
                <Editor
                  value={text}
                  onTextChange={(e) => setText(e.htmlValue)}
                  style={{ height: "320px" }}
                />
              </div>
            </div>

            <button type="submit" className="btn btn-primary">
              Submit
            </button>
          </form>
        </div>
      </div>

    </>
  );
};
export default JobPosts;
